import { agentService, eventService } from '../../services/homii-services';
import { mediaUtil } from '../utils';

async function getAgentsDetailsByPortfolioId(portfolioId) {    
    const fetchedAgencies = await agentService
        .getAgentByPortfolioId(portfolioId)
        .then((agents) => {
            let agentsWithImages = [];
            _.map(agents, (agent) => {
                const agentWithImages = mediaUtil.generateAgentImageUrls(agent);
                agentsWithImages.push(agentWithImages);
            });
            return agentsWithImages;
        });
    return fetchedAgencies;
    
}

async function getAgentDetailsById(id) {    
    const fecthedAgent = await agentService
        .getAgentById(id)
        .then((response) => {
            const agentWithImages = mediaUtil.generateAgentImageUrls(response);
            return agentWithImages;
        });
    return fecthedAgent        
}

function submitAgentInquiry(
    agentId,
    roomTypeId,
    firstName,
    lastName,
    phoneNumber,
    email,
    inquiry,
) {
    try {
        agentService.submitAgentInquiry(
            agentId,
            roomTypeId,
            firstName,
            lastName,
            phoneNumber,
            email,
            inquiry,
        );
        eventService.logCustomEvent('successful_agent_inquiry', {
            description: 'Successfuly submitted an agent inquiry',
        });
    } catch (error) {
        throw Error(
            _.get(
                error,
                'response.data.message',
                'An error occurred while trying to submit your inquiry.',
            ),
        );
    }
}

export default {
    getAgentDetailsById,
    getAgentsDetailsByPortfolioId,
    submitAgentInquiry
}